import {
  ApiTokenListResponse,
  BookingAgendaResult,
  CalendarEventOccurrenceAsMember,
  EventOccurrenceDTO,
  EventRsvpCustomerDTO,
  EventRsvpFeeInvoiceDTO,
} from "@gymflow/types";
import { AxiosInstance } from "axios";

const customerOccurrence = (axiosInstance: AxiosInstance, clubId: number) => {
  const clubPrefix = `club/${clubId}/`;

  return {
    findById(id: number) {
      return axiosInstance.get<EventOccurrenceDTO>(
        `${clubPrefix}customer/event/occurrence/${id}`,
      );
    },
    addAttendeeToRsvp(occurrenceId: number) {
      return axiosInstance.put(`${clubPrefix}customer/event-rsvp`, {
        occurrenceId,
      });
    },
    lateCancel(rsvpId: number, params: { paymentMethodId?: string }) {
      return axiosInstance.put<EventRsvpFeeInvoiceDTO>(
        `${clubPrefix}customer/event-rsvp/${rsvpId}/late-cancel`,
        params,
      );
    },
    bookRsvp(rsvpId: number) {
      return axiosInstance.put(
        `${clubPrefix}customer/event-rsvp/${rsvpId}/book`,
      );
    },
    cancelRsvp(rsvpId: number) {
      return axiosInstance.put(
        `${clubPrefix}customer/event-rsvp/${rsvpId}/cancel`,
      );
    },
    calendarEventOccurrences({
      filters,
    }: {
      filters: {
        dateFrom: string;
        dateTo: string;
        limit: number;
        nextPageToken?: string;
        includeBookedCounts?: boolean;
        includeWaitingCounts?: boolean;
        eventHostId?: string[];
        facilityId?: number[];
        activityId?: number[];
        isPublicEvent?: boolean;
        activityCategoryId?: number[];
      };
    }) {
      return axiosInstance.get<
        ApiTokenListResponse<CalendarEventOccurrenceAsMember>
      >(`${clubPrefix}customer/calendar/event-occurrences`, {
        params: filters,
      });
    },

    userMemberBookingAgenda({
      filters,
    }: {
      filters: {
        limit: number;
        nextPageToken?: string;
        includeBookedCounts?: boolean;
        includeWaitingCounts?: boolean;
      };
    }) {
      return axiosInstance.get<ApiTokenListResponse<BookingAgendaResult>>(
        `${clubPrefix}customer/user-member-booking-agenda`,
        {
          params: filters,
        },
      );
    },
    eventRsvpUpcoming({
      filters,
    }: {
      filters: {
        limit?: number;
        nextPageToken?: string;
        activityId?: number[];
        eventHostId?: string[];
        activityCategoryId?: number[];
        eventFacilityId?: number[];
      };
    }) {
      return axiosInstance.get<ApiTokenListResponse<EventRsvpCustomerDTO>>(
        `${clubPrefix}customer/event-rsvp/upcoming`,
        { params: filters },
      );
    },
    eventRsvpPast({
      filters,
    }: {
      filters: {
        limit?: number;
        nextPageToken?: string;
        activityId?: number[];
        eventHostId?: string[];
        activityCategoryId?: number[];
        eventFacilityId?: number[];
      };
    }) {
      return axiosInstance.get<ApiTokenListResponse<EventRsvpCustomerDTO>>(
        `${clubPrefix}customer/event-rsvp/past`,
        { params: filters },
      );
    },
  };
};

export default customerOccurrence;
